import React from "react";
import { Paragraph } from "@smartsuite/react-ui/lib/components/typography/Paragraph/Paragraph";
import { Tooltip } from "@smartsuite/react-ui/lib/components/help/Tooltip/Tooltip";
import { Icon } from "@smartsuite/react-ui/lib/components/utils/Icon/Icon";
import { Colors, GrayColors } from "@smartsuite/types";
const ProgressBar = ({ progress, max, progressColor, completeColor, }) => {
    const percentage = Math.min(Math.round((progress / max) * 100), 100);
    return (React.createElement("div", { style: {
            width: "100%",
            height: "4px",
            borderRadius: "5px",
            backgroundColor: GrayColors["G-1-5"],
            border: "none",
        } },
        React.createElement("div", { style: {
                height: "100%",
                width: `${percentage}%`,
                borderRadius: "inherit",
                backgroundColor: percentage === 100 ? completeColor : progressColor,
            } })));
};
const UsageHelpIconWrapper = ({ isAdmin, setupUrl, children }) => {
    if (isAdmin) {
        return (React.createElement("a", { href: setupUrl, target: "_blank", rel: "noreferrer" }, children));
    }
    return React.createElement(React.Fragment, null, children);
};
const helpTooltip = {
    admin: `Your workspace has 200 free AI Requests tokens. Click to enter your own key and continue using SmartSuite AI after your tokens run out.`,
    user: `Your workspace has 200 free AI Requests tokens.
          After those ran out, your administrator will have to enter your own key in order to continue using SmartSuite AI`,
};
const UsageHelpButton = ({ isAdmin, setupUrl, }) => {
    const message = isAdmin ? helpTooltip.admin : helpTooltip.user;
    return (React.createElement(Tooltip, { placements: ["top", "bottom"], text: message, padding: 8, target: React.createElement(UsageHelpIconWrapper, { isAdmin: isAdmin, setupUrl: setupUrl },
            React.createElement(Icon, { name: "is-help", size: "M", color: GrayColors["G-3"], className: "ai-popup-usage__help-icon" })) }));
};
export const AiUsage = ({ current = 0, limit = 200, setupUrl, isAdmin = false, userHasOwnKey = false, }) => {
    if (userHasOwnKey) {
        return null;
    }
    const limitReached = current >= limit;
    return (React.createElement("div", { className: "ai-popup-usage" },
        React.createElement("div", { className: "ai-popup-usage__stats" },
            React.createElement("div", { className: "ai-popup-usage__display" },
                React.createElement(ProgressBar, { progress: current, max: limit, progressColor: Colors.bGreen, completeColor: Colors.bRed })),
            React.createElement(Paragraph, { className: "ai-popup-usage__text", size: "xs", weight: "regular", color: GrayColors["G-0-5"] },
                current,
                " / ",
                limit,
                " Free Requests"),
            React.createElement(UsageHelpButton, { isAdmin: isAdmin, setupUrl: setupUrl })),
        (limitReached || isAdmin) && (React.createElement("div", { className: `ai-popup-usage__config ${limitReached ? "ai-popup-usage__config-over-limit" : ""}` },
            !limitReached && (React.createElement("a", { href: setupUrl || "#", target: "_blank", rel: "noreferrer", className: "ai-popup-usage__config-link" }, "Enter your own key")),
            limitReached && (React.createElement(React.Fragment, null,
                React.createElement(Paragraph, { className: "ai-popup-usage__warn", weight: "bold", size: "xs" }, "AI is not available anymore."),
                React.createElement(Paragraph, { className: "ai-popup-usage__config-warn", weight: "regular", size: "xs" }, isAdmin ? (React.createElement(React.Fragment, null,
                    React.createElement("a", { href: setupUrl || "#", target: "_blank", rel: "noreferrer", className: "ai-popup-usage__config-link" }, "Enter your own key"),
                    React.createElement("span", null, " to continue using it."))) : (React.createElement("span", null, "Admin has to enter their own key.")))))))));
};
